import { ApiTypes } from "types"
import SubscriptionPlan from "types/enums/SubscriptionPlan"
import SubscriptionPrivilege from "types/enums/SubscriptionPrivilege"

const SubscriptionPrivileges: Record<SubscriptionPlan, SubscriptionPrivilege[]> = {
  [SubscriptionPlan.GO]: [],
  [SubscriptionPlan.BASIC]: [SubscriptionPrivilege.MessageCenter],
  [SubscriptionPlan.BASIC_MAY_2025]: [SubscriptionPrivilege.MessageCenter],
  [SubscriptionPlan.BASIC_OCT_2025]: [],
  [SubscriptionPlan.BASIC_DEC_2025]: [
    SubscriptionPrivilege.Alerts,
    SubscriptionPrivilege.Monitoring,
    SubscriptionPrivilege.PerformanceTest,
  ],
  [SubscriptionPlan.PLUS]: [
    SubscriptionPrivilege.Monitoring,
    SubscriptionPrivilege.PerformanceTest,
    SubscriptionPrivilege.Alerts,
    SubscriptionPrivilege.MessageCenter,
  ],
  [SubscriptionPlan.PLUS_MAY_2025]: [
    SubscriptionPrivilege.Monitoring,
    SubscriptionPrivilege.PerformanceTest,
    SubscriptionPrivilege.MessageCenter,
  ],
  [SubscriptionPlan.NETWORK]: [
    SubscriptionPrivilege.Monitoring,
    SubscriptionPrivilege.PerformanceTest,
    SubscriptionPrivilege.Alerts,
    SubscriptionPrivilege.MessageCenter,
  ],
  [SubscriptionPlan.E_PLUS]: [
    SubscriptionPrivilege.Monitoring,
    SubscriptionPrivilege.PerformanceTest,
    SubscriptionPrivilege.Alerts,
    SubscriptionPrivilege.MessageCenter,
  ],
  [SubscriptionPlan.SUPREME]: [
    SubscriptionPrivilege.Monitoring,
    SubscriptionPrivilege.PerformanceTest,
    SubscriptionPrivilege.Alerts,
  ],
  [SubscriptionPlan.CONNECT]: [SubscriptionPrivilege.MessageCenter],
  [SubscriptionPlan.GROWTH]: [
    SubscriptionPrivilege.Monitoring,
    SubscriptionPrivilege.PerformanceTest,
    SubscriptionPrivilege.Alerts,
    SubscriptionPrivilege.MessageCenter,
  ],
}

const hasSubscriptionAccess = (user: ApiTypes.Model.UserProfile, privilege: SubscriptionPrivilege) => {
  const privileges = SubscriptionPrivileges[user?.contractor?.subscription_plan || SubscriptionPlan.BASIC]

  return privileges.includes(privilege)
}

export default hasSubscriptionAccess
